// extracted by mini-css-extract-plugin
export default {"root":"SellerLandingPage_root__Mtp6i","content":"SellerLandingPage_content__sEsta"};